const cleanToken = (value) => decodeURIComponent(String(value || '').replace(/[?#].*$/, ''));

export const parseGaliLink = (value = '') => {
  const raw = String(value || '').trim();
  if (!raw) return null;

  const parsePath = (pathname) => {
    const path = String(pathname || '').replace(/\/+$/, '');
    let match = path.match(/\/gali\/public\/([^/]+)/i);
    if (match) return { type: 'public', publicToken: cleanToken(match[1]), path: `/gali/public/${cleanToken(match[1])}` };
    match = path.match(/\/gali\/invites\/([^/]+)/i);
    if (match) return { type: 'invite', inviteToken: cleanToken(match[1]), path: `/gali/invites/${cleanToken(match[1])}` };
    match = path.match(/\/gali\/match\/([^/]+)\/invite\/([^/]+)/i);
    if (match) return { type: 'invite', matchId: cleanToken(match[1]), inviteToken: cleanToken(match[2]), path: `/gali/invites/${cleanToken(match[2])}` };
    return null;
  };

  const direct = parsePath(raw);
  if (direct) return direct;

  if (/^crickarena:\/\//i.test(raw)) {
    const path = raw.replace(/^crickarena:\/\//i, '/');
    return parsePath(path);
  }

  try {
    const url = new URL(raw);
    return parsePath(url.pathname);
  } catch (_error) {
    return null;
  }
};
